/**
 * Whether a date is more than `thresholdYears` old, compared by calendar year only
 * (ignoring month/day), relative to the current year.
 */
export const isContentOutdated = (date?: Date | string | null, thresholdYears = 1): boolean => {
  if (!date) return false;

  const contentDate = date instanceof Date ? date : new Date(date);
  if (isNaN(contentDate.getTime())) return false;

  const currentYear = new Date().getFullYear();
  return currentYear - contentDate.getFullYear() >= thresholdYears;
};
